import React from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import VehicleNonDppaRecordDetail from "./VehicleNonDppaRecordDetail";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import { getMenuItem } from "../common/PageHelper";

class VehicleNonDppaResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    let tabHeader;
    let resultsCount = 0;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      const resultNodes = _.get(
        props.searchResultData,
        "vehicles.response[0].auto"
      );
      const showNarrowSearchMessage =
        resultNodes !== undefined && resultNodes.length > 25;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );

      if (resultNodes)
        _.forEach(resultNodes, (node, index) => {
          const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
          results.push(
            <Table.Row key={`VehicleInfo_Row_${index}`} className={colorClass}>
              <Table.Cell>
                <VehicleNonDppaRecordDetail node={node} {...this.props} />
              </Table.Cell>
            </Table.Row>
          );
        });
      resultsCount = results.length;
    }
    this.state = {
      results,
      resultsCount,
      tabHeader,
    };
  };

  showReport = (internalID) => {
    this.props.showReport(undefined, "aReport", undefined, {
      optReportType: "vehicle",
      lookupID: internalID,
      internalID,
    });
  };

  render() {
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${this.state.resultsCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {this.state.tabHeader}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(VehicleNonDppaResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/VehicleNonDppaResult.js